import { PdContactUs } from "./pd-contact-us/PdContactUs.js";
//#region src/pd-contact-us/pd-contact-us.ts
var tag = "pd-contact-us";
if (!customElements.get(tag)) customElements.define(tag, PdContactUs);
//#endregion
export { PdContactUs };
